<template>
    <div id="menu">
        <div class="contentMenu">
            <div id="scrollbar-container" ref="scroll">
                <ul class="nav tabsMenu">
                    <li
                        v-for="[id, item] in itemsEntries.slice(0, nbMainModules)"
                        :id="`menuli_${id}`"
                        :key="id"
                        class="menuli"
                        :class="{ hasSubMenu: item['sub'] }"
                    >
                        <menu-link :item="item" :itemId="id" :activeItem="activeItem" />

                        <span
                            v-if="!item['sub'] && item.id !== 'dashboard'"
                            class="menu-label typographies-paragraph-small-bold"
                        >
                            {{ item.txt }}
                        </span>

                        <ul
                            v-if="item['sub']"
                            :id="`__menu__${id}`"
                            class="hidden tabSubmenu"
                            :style="
                                id === 'ecommerce'
                                    ? '{overflow-y: scroll; max-height: 200px; width: 256px;}'
                                    : ''
                            "
                        >
                            <li class="tabSumenutitle_title">
                                {{ item['txt'] ? item['txt'] : '' }}
                            </li>
                            <li
                                v-for="(sub, subItemId) in item['sub']"
                                :key="subItemId"
                                :class="sub['class'] ? sub['class'] : ''"
                            >
                                <template v-if="!sub['class'] || sub['class'] !== 'separator'">
                                    <menu-link :item="sub" :activeItem="activeItem" />
                                </template>
                            </li>
                        </ul>
                    </li>
                    <el-collapse
                        v-if="itemsEntries.length > nbMainModules"
                        v-model="activeName"
                        @change="onChangeCollapse"
                    >
                        <el-collapse-item name="1">
                            <template #icon>
                                <CompassIcon
                                    icon="caret-down"
                                    size="large"
                                    type="primary-contrast"
                                />
                            </template>
                            <template #title>
                                <span v-if="fullMenu">
                                    {{ activeName === '1' ? $l10n.__('Moins') : $l10n.__('Plus') }}
                                </span>
                            </template>
                            <li
                                v-for="[id, item] in itemsEntries.slice(
                                    nbMainModules,
                                    itemsEntries.length,
                                )"
                                :id="`menuli_${id}`"
                                :key="id"
                                class="menuli"
                                :class="{ hasSubMenu: item['sub'] }"
                            >
                                <menu-link :item="item" :itemId="id" :activeItem="activeItem" />

                                <span
                                    v-if="!item['sub'] && item.id !== 'dashboard'"
                                    class="menu-label typographies-paragraph-small-bold"
                                >
                                    {{ item.txt }}
                                </span>

                                <ul
                                    v-if="item['sub']"
                                    :id="`__menu__${id}`"
                                    class="hidden tabSubmenu"
                                    :style="
                                        id === 'ecommerce'
                                            ? '{overflow-y: scroll; max-height: 200px; width: 256px;}'
                                            : ''
                                    "
                                >
                                    <li class="tabSumenutitle_title">
                                        {{ item['txt'] ? item['txt'] : '' }}
                                    </li>
                                    <li
                                        v-for="(sub, subItemId) in item['sub']"
                                        :key="subItemId"
                                        :class="sub['class'] ? sub['class'] : ''"
                                    >
                                        <template
                                            v-if="!sub['class'] || sub['class'] !== 'separator'"
                                        >
                                            <menu-link :item="sub" :activeItem="activeItem" />
                                        </template>
                                    </li>
                                </ul>
                            </li>
                        </el-collapse-item>
                    </el-collapse>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import MenuLink from './MenuLink.vue';
import { urlMenuIdAdditionnally } from 'Config/authenticated/AdditionallyRouteMenuId';
import { hasEveryProp, couple } from 'utils/functional.js';
import LocalStorage from 'Core/commons/LocalStorage';
import PerfectScrollbar from 'perfect-scrollbar';

const navItemSorter = {
    dashboard: 0,
    contacts: 1,
    prospection: 2,
    invoicing: 3,
    purchases: 4,
    payments: 5,
    catalogue: 6,
    cashflow: 7,
    accounting: 8,
    recurring: 9,
    massmailing: 10,
    proposal: 11,
    support: 12,
    reports: 13,
    briefcasev2: 14,
    mailing: 15,
    timetracking: 16,
    expenses: 17,
    project: 18,
    pos: 19,
    stock: 20,
};

export default {
    components: {
        'menu-link': MenuLink,
    },
    props: {
        items: {
            type: Object,
            required: true,
        },
        defaultActiveItem: {
            type: String,
            required: false,
            default: '',
        },
        defaultFullMenu: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            activeName: null,
            activeItem: this.defaultActiveItem,
            fullMenu: this.defaultFullMenu,
            menuPaths: {},
            scrollbarOptions: {
                suppressScrollX: true,
                maxScrollbarLength: 150,
                wheelSpeed: 1,
                wheelPropagation: true,
                minScrollbarLength: 20,
            },
            itemsEntries: [],
            nbMainModules: 15,
            localstorage: new LocalStorage('mainMenu', 'settings'),
            perfectScrollbar: null,
        };
    },
    created() {
        this.sortItems(this.items);
        this.storeMenuPaths(this.items);

        window.EventBus.on('main-menu:activeLinkChanged', this.changeActiveLink);
        window.EventBus.on('main-menu:sizeChanged', this.menuSizeChanged);
    },
    unmounted() {
        this.$refs.scroll.removeEventListener('ps-scroll-y', this.onScroll);
        EventBus.off('main-menu:activeLinkChanged');
        EventBus.off('main-menu:sizeChanged');
    },
    mounted() {
        this.menuSizeChanged({ fullMenu: this.fullMenu });
        this.perfectScrollbar = new PerfectScrollbar(this.$refs.scroll, this.scrollbarOptions);
        this.$refs.scroll.addEventListener('ps-scroll-y', this.onScroll);
        this.initMenu();
        this.listenToMenuHover();
    },
    methods: {
        /**
         * Store in localStorage if collapse menu is open
         * And if is open update size of scrollbar menu
         */
        onChangeCollapse(isOpen) {
            this.localstorage.set({ ...this.localstorage.get(), activeName: isOpen });
            if (isOpen) {
                // wait the end of the duration of collapse animation before recalculate container of scrollbar
                setTimeout(() => this.perfectScrollbar.update(), 500);
            } else {
                this.localstorage.set({ ...this.localstorage.get(), scrollbarYTop: 0 });
            }
        },
        /**
         * Store in localStorage position of scrollbarYTop
         */
        onScroll() {
            this.localstorage.set({
                ...this.localstorage.get(),
                scrollbarYTop: this.perfectScrollbar.scrollbarYTop,
            });
        },
        /**
         * Sort items according with navItemSorter
         */
        sortItems(items) {
            this.itemsEntries = Object.entries(items).sort((a, b) => {
                return navItemSorter[a[0]] - navItemSorter[b[0]];
            });
        },
        /**
         * Find in localStorage state of collapse menu and scoll position
         */
        initMenu() {
            const menuSettingsStorage = this.localstorage.get();

            if (!menuSettingsStorage) {
                this.localstorage.set({ activeName: this.activeName, scrollbarYTop: 0 });
            } else {
                this.activeName = menuSettingsStorage.activeName;
            }

            if (this.activeName) {
                setTimeout(() => {
                    this.perfectScrollbar.update();
                    this.perfectScrollbar.scrollbarYTop = menuSettingsStorage.scrollbarYTop;
                }, 500);
            }
        },
        /**
         * Listener needed for good display of menu, submenu and scollbar
         */
        listenToMenuHover() {
            const menu = $('#menu');
            const scrollContainer = $('#menu div.ps');

            // main menu
            $('.menuli').hover(
                (elem) => {
                    // li is active
                    $(elem.currentTarget).addClass('active');

                    let menuWithoutSubmenuLabelSize = 0;
                    if ($(elem.currentTarget).children('.menu-label').length > 0) {
                        const currentMenuLabel = $(elem.currentTarget).children('.menu-label')[0];
                        menuWithoutSubmenuLabelSize =
                            currentMenuLabel.offsetLeft + currentMenuLabel.offsetWidth;
                    }

                    // calculate width scroll container
                    $(elem.currentTarget).hasClass('hasSubMenu')
                        ? menu.hasClass('menuWithoutText')
                            ? scrollContainer.width(64 + 256)
                            : scrollContainer.width(180 + 256)
                        : menu.hasClass('menuWithoutText')
                            ? scrollContainer.width(
                                menuWithoutSubmenuLabelSize > 0 ? menuWithoutSubmenuLabelSize : 64,
                            )
                            : scrollContainer.width(180);

                    // check subMenu position
                    const subMenu = $(elem.currentTarget).find('ul');
                    if (!!subMenu.length) {
                        const subMenuTop = subMenu.offset().top;
                        const subMenuBottom = subMenuTop + subMenu.outerHeight();

                        const viewportTop = $(window).scrollTop();
                        const viewportBottom = viewportTop + $(window).height();

                        if (subMenuBottom > viewportBottom && subMenuTop < viewportBottom) {
                            const topPosition =
                                subMenuTop -
                                subMenu.outerHeight() +
                                $(elem.currentTarget).outerHeight();
                            // We make sure that the menu does not exceed from the top of the viewport
                            subMenu.css('top', topPosition > 60 ? `${topPosition}px` : '8.5rem');
                            subMenu.css('position', 'fixed');
                        }
                    }
                },
                (elem) => {
                    // li is not active any more
                    $(elem.currentTarget).removeClass('active');

                    // Reset subMenu position
                    const subMenu = $(elem.currentTarget).find('ul');
                    if (!!subMenu.length) subMenu.removeAttr('style');
                    scrollContainer.removeAttr('style');
                },
            );
            // sub menu
            $('.tabsMenu ul.tabSubmenu').hover(null, (elem) => {
                const elemB = $(elem.currentTarget).parent();
                setTimeout(() => {
                    // Reset scrollContainer width
                    const isActiveMainMenu = elemB.hasClass('active');
                    if (!isActiveMainMenu) scrollContainer.removeAttr('style');
                });
            });
        },
        /**
         * Find for the active route, the associated menuId
         */
        changeActiveLink({ activeRoute }) {
            // case : (vue) route => futur solution
            if (activeRoute.meta && activeRoute.meta.menuId) {
                this.activeItem = activeRoute.meta.menuId;
            }

            // case : (legacy || beta) route
            else {
                const { fullPath } = activeRoute;
                let activePath;

                // case legacy route
                if (fullPath.startsWith('/?_f=')) {
                    activePath = this.menuPaths[fullPath] ? fullPath : fullPath.split('&')[0];
                }
                // case beta route
                else {
                    activePath = fullPath.endsWith('?enable-beta')
                        ? fullPath.split('?enable-beta')[0]
                        : fullPath;
                }

                this.activeItem = this.menuPaths[activePath] || this.defaultActiveItem;
            }
        },
        menuSizeChanged(payload) {
            this.fullMenu = payload.fullMenu;

            //change menu size, brand logo size and global container
            if (this.fullMenu) {
                $('.navbar-brand').removeClass('brand-small');
                $('.navbar-container').removeClass('brand-small');
                $('#contentDiv').removeClass('has-sidebar-closed');
                $('#menu').removeClass('menuWithoutText');
            } else {
                $('.navbar-brand').addClass('brand-small');
                $('.navbar-container').addClass('brand-small');
                $('#contentDiv').addClass('has-sidebar-closed');
                $('#menu').addClass('menuWithoutText');
            }

            window.EventBus.emit('main-menu:on-size-changed', { isFullMenu: this.fullMenu });
        },
        /**
         * Store localy an object of few [url]:menuId
         * calculated with all url of menu, all routes of vue with menuId and additional routes of a config file
         *
         * @param {Object} items - all items of menu
         * @return {void}
         */
        storeMenuPaths(items) {
            // Spécific function to flatten an array of route objects
            const flatten = (current, extract, menuId, parentPath) =>
                Array.prototype.concat.apply(
                    current.map((x) => ({
                        ...x,
                        path: parentPath ? `${parentPath}/${x.path}` : x.path,
                        menuId,
                    })),
                    current.map((x) => flatten(extract(x) || [], extract, menuId, x.path)),
                );
            // Spécific function to extract an array of sub route objects (use inside flatten function)
            const extractProp = (prop) => (item) => item[prop];

            // get all Menu Routes
            const urlMenuIdMenuRoutes = Object.entries(items)
                .flatMap(([key, item]) => flatten([item], extractProp('sub'), key))
                .filter(hasEveryProp('url', 'menuId'))
                .reduce(couple('url', 'menuId'), {});
            // get all Vue Routes with meta menuId
            const urlMenuIdVueRoutes = flatten(this.$router.options.routes, extractProp('children'))
                .map((x) => delete x.children && x)
                .filter(hasEveryProp('meta.menuId'))
                .reduce(couple('path', 'meta.menuId'), {});
            this.menuPaths = {
                ...urlMenuIdVueRoutes,
                ...urlMenuIdMenuRoutes,
                ...urlMenuIdAdditionnally,
            };
        },
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;
@import '~perfect-scrollbar/css/perfect-scrollbar.css';

#menu,
main-menu {
    position: fixed;
    z-index: 998;
    top: 60px;
    left: 0;

    width: 180px;
    height: calc(100% - 60px);

    background-color: $dark-blue;

    #scrollbar-container {
        position: relative;
    }

    /**	MENU GLOBAL CSS **/
    li {
        position: relative;

        clear: both;

        width: 100%;
        height: auto;

        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        text-transform: none;
        list-style-type: none;

        a,
        router-link {
            cursor: pointer;

            position: relative;

            height: 100%;
            margin: 0;

            color: rgba($color: $white, $alpha: 70%);
            text-align: left;
            text-decoration: none;
            text-transform: none;

            background-image: none;

            &:hover {
                color: $white !important;

                .external-chip__icon-with-text {
                    opacity: 1;
                }
            }
        }
    }

    .fa {
        width: 24px;
        min-width: 24px;
        height: 24px;

        font-size: 20px;
        line-height: 24px;
        text-align: center;
        vertical-align: middle;
    }

    /**	SCROLLBAR **/
    .ps {
        width: 180px;
        height: 100%;

        .ps__rail-y {
            left: 0;
            left: 165px;
            height: 0 !important;
            opacity: 0.6;

            &:not(.ps--clicking) {
                transition: top 350ms ease;
            }
        }

        .ps__thumb-y,
        .ps__rail-y:hover > .ps__thumb-y,
        .ps__rail-y:focus > .ps__thumb-y,
        .ps__rail-y.ps--clicking .ps__thumb-y {
            width: 5px;
            background-color: rgba($white, 0.4);
        }
    }

    /**	MAIN MENU **/
    .tabsMenu {
        margin: 0;
        padding-top: $val-3;
        padding-bottom: 130px;

        li.menuli {
            width: 180px;
            height: 40px;

            .menu-label {
                opacity: 0;
                visibility: hidden;
                color: var(--colors-common-text-standard-on-color);
                text-align: center;
                position: absolute;
                left: calc(100% + var(--spacing-0));
                top: 50%;
                transform: translateY(-50%);
                padding: var(--spacing-0) var(--spacing-1);
                border-radius: 4px;
                background-color: var(--colors-component-background-sidebar-hover);
                transition: all ease-in-out 0.2s;
            }

            &:hover.hasSubMenu {
                &::after {
                    cursor: pointer;
                    content: ' ';

                    position: absolute;
                    z-index: 1;
                    top: 0;
                    right: 0;

                    width: 12px;
                    height: 40px;

                    background-color: $dark-blue-selected;
                }

                a,
                router-link {
                    margin-right: 0;
                    margin-left: 12px;
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                }
            }

            &:hover {
                a,
                router-link {
                    text-decoration: none;
                    background-color: $dark-blue-selected;
                }

                .tabSubmenu {
                    position: absolute;
                    z-index: 1;
                    display: block;
                }
            }

            > a,
            > router-link {
                display: flex;
                align-items: center;
                justify-content: flex-start;

                margin: 4px 12px;
                padding: 0 10px 0 8px;

                border-radius: 4px;

                span.menu--label {
                    padding-left: 12px;
                    font-weight: 600;
                }

                &.current {
                    color: $white !important;
                    background-color: $dark-blue-selected;
                }
            }
        }
    }

    /**	SUB MENU **/
    .tabSubmenu {
        position: absolute;
        z-index: -1;
        top: 0;
        left: 180px;

        clear: both;
        overflow: hidden;
        display: none;

        width: 256px;
        margin: 0;
        padding: 0;
        padding-bottom: 8px;

        list-style: none;

        background-color: $dark-blue-selected;
        border-top: none;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;

        li {
            padding: 8px 16px;

            &.tabSumenutitle_title {
                display: none;

                height: 40px;

                font-weight: 700;
                color: $white;
                text-align: left;
            }

            &.separator {
                height: 1px;
                padding: 0;
                border-bottom: 1px solid $dark-blue-selected;
            }

            a,
            router-link {
                margin-left: 0 !important;
            }
        }

        &#__menu__massmailing li.separator {
            margin: 8px 16px;
            width: auto;
            border-bottom: 1px solid rgba($color: $white, $alpha: 70%);
        }
    }

    /**	COLLAPSE MENU **/
    .el-collapse {
        border: none;

        .el-collapse-item__header {
            width: 180px;
            padding-left: 20px;

            color: rgba($white, 0.7);
            text-align: left;

            background-color: $dark-blue;
            border-bottom: none;

            display: flex !important;
            align-items: center;
            gap: 4px;
            flex-direction: row-reverse;
            justify-content: flex-end;

            &:hover {
                color: $white;
            }

            &.is-active {
                .compass-icon {
                    transform: rotate(-180deg);
                }
            }

            .compass-icon {
                margin: 0;
                text-align: center;
                vertical-align: middle;

                transition-duration: 450ms;
            }

            .el-collapse-item__arrow.el-icon-arrow-right {
                display: none;
            }
        }

        .el-collapse-item__wrap {
            position: absolute;
            background-color: transparent;
            border-bottom: none;
            width: calc(180px + 256px);

            transition-duration: 0ms;

            .el-collapse-item__content {
                width: 100%;
                padding-bottom: 130px;
            }
        }
    }

    /**	SPECIFIC	**/
    #menuli_ecommerce .tabSubmenu li a {
        overflow: hidden;
        width: 100%;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    /**	CLOSED MENU	**/
    &.menuWithoutText {
        width: 64px;

        /**	SCROLLBAR **/
        .ps {
            width: 64px;

            .ps__rail-y {
                left: 49px;
            }
        }

        /**	MAINMENU **/
        .tabsMenu li.menuli {
            width: 64px;

            &:hover {
                .menu-label {
                    opacity: 1;
                    visibility: visible;
                }
            }

            > a {
                span.menu--label {
                    display: none;
                }

                &:hover {
                    span.external-chip__icon {
                        opacity: 1;
                    }
                }
            }
        }

        /**	SUBMENU **/
        .tabSubmenu {
            left: 64px;

            li {
                width: 100%;
            }

            .tabSumenutitle_title {
                display: flex;
                align-items: center;
            }
        }

        /**	COLLAPSE MENU **/
        .el-collapse {
            .el-collapse-item__header {
                width: 64px;
            }

            .el-collapse-item__wrap {
                width: calc(64px + 256px);
            }
        }
    }
}
</style>
